module.exports = __webpack_public_path__ + "static/media/post-it.49e915ac.svg";